export class Park {
    code: string;
    displayCode: string;
    frontEndCode: string;
    name: string;
    energyMeterAvailable: boolean;
    country: string;
    countryCode: string;
    lat: number;
    lon: number;
    timezone: string;
    id: string;
    useRevenuesV2InBudgets: boolean;
    groups?: {
        id: string;
        name: string;
        turbines: string[];
    }[];
    constructor(
        id?: string,
        code?: string,
        frontEndcode?: string,
        name?: string,
        country?: string,
        countryCode?: string,
        lat?: number,
        lon?: number,
        timezone?: string,
        groups?,
        energyMeterAvailable?: boolean,
        useRevenuesV2InBudgets?: boolean,
        displayCode?: string
    ) {
        this.id = id;
        this.code = code;
        this.frontEndCode = frontEndcode;
        this.name = name;
        this.country = country;
        this.countryCode = countryCode;
        this.lat = lat;
        this.lon = lon;
        this.timezone = timezone;
        this.groups = groups;
        this.energyMeterAvailable = energyMeterAvailable;
        this.useRevenuesV2InBudgets = useRevenuesV2InBudgets;
        this.displayCode = displayCode;
    }
}
